import React from 'react';
import PropTypes from 'prop-types';

import Image from '@nerdwallet/react-image';
import { Box, Button, Text, Type as Title } from '@nerdwallet/currency';
import styles from './branded-login.module.less';

const BrandedLogin = ({
  onSuccess,
  isSignedIn,
  loginModalCopyOverride,
  loginPageCopyOverride,
  brandedBackgroundImage,
  brandedIcon,
  brandedTitle,
  brandedSubtitle,
  customCtaText,
  topLoginBoxColor,
  bottomLoginBoxColor,
  topLoginBoxMargin,
  bottomLoginBoxMargin,
}) => {
  const flowConfig = loginModalCopyOverride
    ? {
        copyOverrides: {
          signinHeading: loginModalCopyOverride,
        },
      }
    : {};

  return (
    <Box
      id="branded-login"
      className={styles.container}
      style={{ backgroundImage: `url(${brandedBackgroundImage})` }}
    >
      <Box
        className={styles.card}
        style={{
          borderTopColor: topLoginBoxColor || '#8a1c32',
          borderBottomColor: bottomLoginBoxColor || '#ffc627',
          marginTop: topLoginBoxMargin || 212,
          marginBottom: bottomLoginBoxMargin || 212,
        }}
      >
        {brandedIcon && (
          <Image
            className={styles.cardIcon}
            src={brandedIcon}
            alt="NerdWallet Brand"
            backgroundColor="transparent"
            naturalHeight={318}
            naturalWidth={289}
          />
        )}
        <Box className={styles.cardHeading}>
          <Title className={styles.cartTitle} size="3">
            {loginPageCopyOverride || brandedTitle}
          </Title>
          <Box className={styles.cardSubtitle}>
            <Text component="p">{brandedSubtitle}</Text>
          </Box>
        </Box>
        {!isSignedIn ? (
          <div>
            <Button
              onClick={() =>
                window.nwapi.ui.showAuthDialog({
                  flow: 'basic',
                  version: 2,
                  authType: 'signin',
                  onSuccess,
                  flowConfig,
                })
              }
            >
              {customCtaText || 'SIGN IN OR CREATE ACCOUNT'}
            </Button>
          </div>
        ) : null}
      </Box>
    </Box>
  );
};

BrandedLogin.displayName = 'Branded Login';

BrandedLogin.propTypes = {
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginModalImgOverride: PropTypes.string,
  loginModalCopyOverride: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
  brandedBackgroundImage: PropTypes.string,
  brandedIcon: PropTypes.string,
  brandedTitle: PropTypes.string,
  brandedSubtitle: PropTypes.string,
  customCtaText: PropTypes.string,
  topLoginBoxColor: PropTypes.string,
  bottomLoginBoxColor: PropTypes.string,
  topLoginBoxMargin: PropTypes.number,
  bottomLoginBoxMargin: PropTypes.number,
};

export default BrandedLogin;
